import type { OperationModel } from "~/core/models/OperationModel.interface";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

/**
 * Check if the operation model is enabled based on license features.
 * Returns true if:
 * - No enabledLicenceFeature is defined on the operation model, OR
 * - The feature is enabled in the current license
 */
export const checkIsOperationModelEnabled = (
  operationModel?: OperationModel,
) => {
  const { isLicenseFeatureEnabled } = useLicenseStore();
  // Check if the attribute enabledLicenceFeature is defined
  if (!operationModel?.enabledLicenceFeature) {
    return true;
  }

  // Check if the feature is enabled in the license
  return isLicenseFeatureEnabled(operationModel.enabledLicenceFeature);
};
